module.exports = __webpack_public_path__ + "assets/voice_icon.3b8fd299.svg";